import React from 'react';
import { useSelector } from 'react-redux';
import {
  StatusBar, SafeAreaView, StyleSheet, View, ImageBackground, Pressable, Text,
} from 'react-native';
import { PieChart } from 'react-native-svg-charts';
import { G, Text as SvgText } from 'react-native-svg';
import * as Linking from 'expo-linking';
import Header from '../components/Header';
import GradientButton from '../components/GradientButton';
import APMStyles from '../styles';

const cardImg = require('../assets/images/apm-hand.jpg');

function WorkoutComplete({ navigation }) {
  const { targets } = useSelector((state) => state.training.workout);

  const pieChartData = [
    {
      name: 'thumb',
      value: targets.thumb,
      color: '#26D0CE',
    },
    {
      name: 'wrist',
      value: targets.wrist,
      color: '#B05EE0',
    },
    {
      name: 'flexor',
      value: targets.flexor,
      color: '#F77493',
    },
    {
      name: 'extensor',
      value: targets.extensor,
      color: '#E08C5E',
    },
    {
      name: 'fingers',
      value: targets.fingers,
      color: '#FCD26A',
    },
    {
      name: 'pinky',
      value: targets.pinky,
      color: '#6ba4ff',
    },
    {
      name: 'index',
      value: targets.index,
      color: '#6EF768',
    },
    {
      name: 'lumbrical',
      value: targets.lumbrical,
      color: '#1e82a6',
    },
  ];

  const PieChartLabels = ({ slices }) => slices.map((slice) => {
    const { labelCentroid, data } = slice;
    return (
      <G key={data.key} style={{ overflow: 'visible' }}>
        <SvgText
          x={labelCentroid[0]}
          y={labelCentroid[1]}
          fill={data.svg.fill}
          textAnchor="middle"
          alignmentBaseline="middle"
          fontFamily="roboto-700"
        >
          {pieChartData.find((dataEntry) => dataEntry.color === data.svg.fill).name.toUpperCase()}
        </SvgText>
      </G>
    );
  });

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" />
      <Header style={styles.header} navigation={navigation} />

      <View style={styles.chartContainer}>
        <PieChart
          data={
            pieChartData.filter((dataEntry) => dataEntry.value > 0).map((dataEntry, index) => ({
              value: dataEntry.value,
              svg: { fill: dataEntry.color },
              key: index,
            }))
          }
          style={styles.pieChart}
          innerRadius="40%"
          outerRadius="50%"
          labelRadius="80%"
        >
          <PieChartLabels />
        </PieChart>
      </View>

      <Pressable
        onPress={() => Linking.openURL('https://apmbarracks.com')}
        style={styles.card}
      >
        <ImageBackground style={styles.cardCover} source={cardImg}>
          <Text style={styles.cardTitle}>VISIT APM BARRACKS</Text>
        </ImageBackground>
      </Pressable>

      <View style={styles.buttonContainer}>
        <GradientButton
          mode="contained"
          onPress={() => navigation.navigate('Home')}
        >
          RETURN HOME
        </GradientButton>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: APMStyles.colors.background,
  },
  header: {
    flex: 1,
  },
  chartContainer: {
    backgroundColor: APMStyles.colors.background,
    flex: 6,
  },
  pieChart: {
    backgroundColor: APMStyles.colors.background,
    height: '100%',
  },
  card: {
    flex: 4,
  },
  cardCover: {
    flex: 1,
    justifyContent: 'center',
  },
  cardTitle: {
    textAlign: 'center',
    color: APMStyles.colors.text,
    fontSize: APMStyles.typography.button,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: 10,
  },
  buttonContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default WorkoutComplete;
